
<div #barchart class="chartdiv" ></div>
